import { useRole } from '@/hooks/use-role';
import { useClientProfile } from '@/lib/hooks/use-client-profile';

/**
 * Convenience hook for accessing the current user's own client profile
 */
export function useOwnClientProfile() {
  const { clientProfileId } = useRole();
  return useClientProfile(clientProfileId, { enableMutations: true });
}